import { useTranslation } from 'react-i18next'
import { LangText } from '@/components'
import { Form, FormInstance, Input } from 'antd'


interface EmailFormProps {
  form: FormInstance<any>;
  codeLoading: boolean;
  countdown: number;
  sendCaptcha: (account: string) => Promise<boolean>;
  verifyCaptchaAndNext: (account: string, captcha: string) => boolean;
}

const EmailForm = (props: EmailFormProps) => {
  const { codeLoading, countdown, sendCaptcha, form } = props;
  const { t } = useTranslation()
  const handleSendCode = async () => {
    form.validateFields(['email']).then(values => {
      sendCaptcha(values.email);
    })
  };


  return (
    <>
      <Form.Item
        name='email'
        required
        validateTrigger='onBlur'
        label={<LangText lngKey='9b1c6681' className='text-[16px] font-bold'>{t('9b1c6681')}</LangText>}
        rules={[
          { required: true, message: t('f51ccec8') },
          { type: 'email', message: t('aba0aa71') }
        ]}
      >
        <Input placeholder={t('5e21b2f8')} className='h-[44px]' disabled={codeLoading} />
      </Form.Item>
      <Form.Item required className='w-full' label={<LangText lngKey='2638a4d4' className='text-[16px] font-bold'>{t('2638a4d4')}</LangText>}>
        <div className='flex w-full'>
          <Form.Item name='code' noStyle className='flex-1' rules={[{ required: true, message: t('b68e8285') }]}>
            <Input placeholder={t('da67c20b')} className='h-[44px]' />
          </Form.Item>
          <div
            className={`shrink-0 border border-[#5a52ff] rounded-[4px] ml-2 px-3 flex items-center justify-center cursor-pointer ${countdown > 0 || codeLoading ? 'opacity-50 cursor-not-allowed' : ''}`}
            onClick={handleSendCode}
          >
            <LangText lngKey={codeLoading ? '141d18c7' : 'fbdf3b19'} className='text-[14px] text-[#5a52ff] text-nowrap'>
              {codeLoading ? t('141d18c7') : countdown > 0 ? `${countdown}s` : t('fbdf3b19')}
            </LangText>
          </div>
        </div>
      </Form.Item>
    </>
  )
}

export default EmailForm